import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Injector, DoBootstrap } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';

import { EcommerceConfigService } from 'idt-ecommerce-api/config/ecommerce-config.service';
import { ContextService } from 'idt-ecommerce-api/context/context.service';
import { IdtEcommerceApiModule } from 'idt-ecommerce-api/idt-ecommerce-api.module';
import { SegmentationService } from 'shared/services/segmentation.service';
import { SharedConfigurationService } from 'shared/services/shared-configuration.service';

import { RenderPageModule } from './render-page.module';
import { RenderComponent } from './render.component';
import { WithCredentialsInterceptor } from './services/interceptors/with-credentials.interceptor.service';
import { RenderConfigurationService } from './services/render-configuration.service';
import { CookieService } from './services/render-cookies.service';


@NgModule({
  imports: [
    RouterModule.forRoot([], {}),
    StoreModule.forRoot({}),
    BrowserAnimationsModule,
    RenderPageModule,
    IdtEcommerceApiModule,
  ],
  exports: [
    RenderComponent,
    RouterModule
  ],
  declarations: [
    RenderComponent
  ],
  providers: [
    ContextService,
    EcommerceConfigService,
    RenderConfigurationService,
    SharedConfigurationService,
    SegmentationService,
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WithCredentialsInterceptor,
      multi: true
    }
  ]
})
export class RenderWebComponentModule implements DoBootstrap {

  constructor(private readonly injector: Injector) {}

  public ngDoBootstrap(): void {
    const el = createCustomElement(RenderComponent, { injector: this.injector });
    customElements.define('render-idt', el);
  }

}
